export default "__VITE_ASSET__8x5aDhPgUl28ynwFi6Wq7A__";